define('model/TimeValidateModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Validate booking time, using for validate recurring dates, membership limit, etc.
     *
     * @class TimeValidateModel
     */
    return BaseModel.extend({

        urlRoot: '/booking/validate-time/',

        defaults: {
            id: '',
            dates: [],
            error_dates: [],
            error: null
        }

    });

});
